import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, ToastsTitle } from "../../../Constants/Constants";
import LiveToast from "./LiveToast/LiveToast";
import ColorsScheme from "./ColorsScheme";
import StackingToasts from "./StackingToasts/StackingToasts";
import TranslucentToasts from "./TranslucentToasts/TranslucentToasts";
import DefaultToast from "./DefaultToast";
import UniqueToast from "./UniqueToast";
import ToastPlacement from "./ToastPlacement/ToastPlacement";
import { Fragment } from "react/jsx-runtime";
import MessageToasts from "./MessageToasts/MessageToasts";

const ToastsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ToastsTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <MessageToasts />
          <LiveToast />
          <ColorsScheme />
          <StackingToasts />
          <TranslucentToasts />
          <DefaultToast />
          <UniqueToast />
          <ToastPlacement />
        </Row>
      </Container>
    </Fragment>
  );
};
export default ToastsContainer;
